// Lógica pura da trava de coordenada por lado para furo horizontal manual
// (OPÇÃO A — o `lado` MANDA). Extraída de FuroManual.jsx para ser testável sem
// renderizar o componente: o repo testa o EditorMPR por funções puras e não há
// @testing-library instalado.
//
// Regra oficial [CNC] (bancada WoodWOP 6.0.18, 2026-07-24): a borda de ENTRADA
// da broca define o lado. A coordenada PERPENDICULAR à borda é determinada pelo
// lado (fica travada no valor da borda); o usuário só informa a coordenada AO
// LONGO da borda. Isso garante, por construção, que x/y caiam sobre a borda do
// lado — o invariante que o renderer (Canvas3D via extensaoBrocaHorizontal)
// assume ao derivar a borda da GEOMETRIA. Ver docs/dividas/registro.md "furo-manual-lado".
//
//   lado  borda de entrada          coord travada     coord livre
//   XP    X=0 (esquerda)            x = 0             y
//   XM    X=comprimento (direita)   x = comprimento   y
//   YP    Y=0 (superior)            y = 0             x
//   YM    Y=largura (inferior)      y = largura       x
export const EIXO_TRAVADO = { XP: 'x', XM: 'x', YP: 'y', YM: 'y' };
export const EIXO_LIVRE = { XP: 'y', XM: 'y', YP: 'x', YM: 'x' };

export function valorBordaTravada(lado, dims) {
  switch (lado) {
    case 'XP': return 0;
    case 'XM': return Number(dims.comprimento) || 0;
    case 'YP': return 0;
    case 'YM': return Number(dims.largura) || 0;
    default:   return 0;
  }
}

// Constrói as coordenadas x/y coerentes de um furo horizontal a partir do lado
// (trava a perpendicular no valor da borda) e da coordenada livre digitada.
export function coordenadasHorizontais(lado, dims, coordLivre) {
  const travado = EIXO_TRAVADO[lado];
  const borda = valorBordaTravada(lado, dims);
  const livre = parseFloat(coordLivre);
  return travado === 'x'
    ? { x: borda, y: livre }
    : { x: livre, y: borda };
}
